/* ============================================================================
   Diaglows — antwoordenbank voor "Stel uw vraag"

   Waarom dit bestand bestaat
   --------------------------
   De meeste bezoekers stellen dezelfde handvol vragen: wat kost het, kan ik
   opzeggen, werkt kentekenzoeken, in welke talen. Die hoeven niet door een
   AI-model beantwoord te worden. Dat is duurder, trager, en het antwoord kan
   per keer net anders uitpakken terwijl je hier juist één vast verhaal wilt.

   Deze bank draait volledig in de browser. Daardoor werkt de vraagfunctie ook
   op de Shopify-webshop, waar geen eigen server achter zit. Alleen een vraag
   die hier niet herkend wordt gaat door naar het AI-model.

   Variatie
   --------
   Per onderwerp staan meerdere formuleringen. Bij elke beurt wordt de volgende
   gepakt, en die teller blijft in localStorage staan. Stel je morgen dezelfde
   vraag, dan krijg je een andere formulering. Dat leest natuurlijker dan een
   antwoord dat woord voor woord hetzelfde blijft.

   Alle varianten zeggen inhoudelijk hetzelfde. Ze verschillen in toon en
   volgorde, niet in feiten — anders zou je bezoeker bij een tweede bezoek een
   ander verhaal krijgen, en dat is precies wat je niet wilt.

   Plaatshouders die worden ingevuld uit instellingen.json:
     {naam} {prijzen} {proefdagen} {email} {telefoon} {app}
   ========================================================================= */
(function (global) {
  'use strict';

  /* ---------- tekst normaliseren ---------- */
  function normaliseer(tekst) {
    return String(tekst || '')
      .toLowerCase()
      .normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* ---------- plaatshouders ---------- */
  function prijsregels(site) {
    var p = (site && site.prijzen) || {};
    var uit = [];
    Object.keys(p).forEach(function (k) {
      var v = p[k] || {};
      var r = v.naam + ' € ' + v.prijs + ' per maand';
      if (v.vragen) r += ' (' + v.vragen + ' vragen)';
      uit.push(r);
    });
    return uit.join(', ') || 'op aanvraag';
  }
  function vulIn(tekst, site) {
    site = site || {};
    return tekst
      .replace(/\{naam\}/g, site.naam || 'Diaglows')
      .replace(/\{prijzen\}/g, prijsregels(site))
      .replace(/\{proefdagen\}/g, site.proefdagen || 14)
      .replace(/\{email\}/g, site.email || 'info@diaglows.com')
      .replace(/\{telefoon\}/g, site.telefoon || '')
      .replace(/\{app\}/g, site.app_url || 'app.diaglows.com');
  }

  /* ---------- onderwerpen ----------
     Volgorde telt: specifiek vóór algemeen. "wat kost een abonnement" moet bij
     prijs uitkomen, niet bij wat-is, dus prijs staat eerder in de lijst. */
  var ONDERWERPEN = [
    {
      id: 'opzeggen',
      woorden: ['opzeg', 'opzegg', 'contract', 'vastzit', 'vast zit', 'termijn', 'looptijd',
                'cancel', 'kundig', 'jaarcontract', 'verplicht'],
      nl: [
        'U zit nergens aan vast. Het abonnement is maandelijks opzegbaar, zonder opzegtermijn en zonder jaarcontract. Wisselen van pakket kan ook op elk moment.',
        'Maandelijks opzegbaar, en dat menen we ook: geen opzegtermijn, geen jaarcontract, geen kleine lettertjes. U kunt tussentijds ook zo van pakket wisselen.',
        'Geen jaarcontract. U zegt op wanneer u wilt en betaalt de lopende maand nog uit — daarna stopt het gewoon. Overstappen naar een groter of kleiner pakket kan tussendoor.'
      ],
      en: [
        'There is no lock-in. The subscription can be cancelled monthly, with no notice period and no annual contract. You can also switch plans at any time.',
        'Cancel monthly, and we mean it: no notice period, no annual contract, no small print. Switching plans mid-term is fine too.'
      ],
      de: [
        'Sie binden sich an nichts. Das Abonnement ist monatlich kündbar, ohne Kündigungsfrist und ohne Jahresvertrag. Auch das Paket können Sie jederzeit wechseln.',
        'Monatlich kündbar, und das ernst gemeint: keine Kündigungsfrist, kein Jahresvertrag, kein Kleingedrucktes.'
      ]
    },
    {
      id: 'proefperiode',
      woorden: ['proef', 'gratis prober', 'gratis test', 'uitprober', 'trial', 'vrijblijvend prober',
                'eerst prober', 'kosteloos', 'testen'],
      nl: [
        'U kunt {naam} {proefdagen} dagen vrijblijvend uitproberen. Zo ziet u in uw eigen werkplaats wat het oplevert voordat u iets kiest. Aanmelden kan via het contactformulier hieronder.',
        'Ja, dat kan: {proefdagen} dagen proberen zonder verplichting. Onze ervaring is dat de eerste echte storing meestal al genoeg zegt. Laat uw gegevens achter, dan zetten we het voor u klaar.',
        'Zeker. U krijgt {proefdagen} dagen om het in de praktijk te testen, met uw eigen klussen. Bevalt het niet, dan stopt het vanzelf — u hoeft niets op te zeggen.'
      ],
      en: [
        'You can try {naam} free for {proefdagen} days, so you can see what it does with your own jobs before deciding. Sign up via the contact form below.',
        'Yes — {proefdagen} days, no obligation. In our experience the first real fault says enough. Leave your details and we will set it up for you.'
      ],
      de: [
        'Sie können {naam} {proefdagen} Tage unverbindlich testen, mit Ihren eigenen Aufträgen. Anmeldung über das Kontaktformular unten.',
        'Ja — {proefdagen} Tage ohne Verpflichtung. Erfahrungsgemäß sagt die erste echte Störung schon genug.'
      ]
    },
    {
      id: 'extra_kosten',
      woorden: ['per vraag', 'bundel', 'op is', 'opraken', 'extra kost', 'meerkost', 'bijbetal',
                'boven de', 'nabetal', 'verbruik', 'staffel', 'strippenkaart'],
      nl: [
        'Geen kosten per vraag achteraf. Elk pakket bevat een vast aantal vragen per maand: {prijzen}. Heeft u structureel meer nodig, dan stapt u over naar een groter pakket — u krijgt nooit een narekening.',
        'Nee, er komt niets bij. Wat u per maand betaalt is wat het kost, en daar zit een vast aantal vragen in: {prijzen}. Loopt u er tegenaan, dan upgraden we gewoon.',
        'Alles zit in de prijs. Wij werken niet met een strippenkaart of bijbetalen per vraag. De pakketten: {prijzen}. Meer nodig? Dan is een groter pakket goedkoper dan losse vragen.'
      ],
      en: [
        'There are no pay-per-question charges. Every plan includes a fixed number of questions per month: {prijzen}. Need more structurally? You simply move up a plan — no surprise invoice.',
        'Nothing gets added afterwards. What you pay per month is what it costs, questions included: {prijzen}.'
      ],
      de: [
        'Keine Kosten pro Frage im Nachhinein. Jedes Paket enthält eine feste Anzahl Fragen pro Monat: {prijzen}. Brauchen Sie dauerhaft mehr, wechseln Sie in ein größeres Paket.',
        'Es kommt nichts dazu. Was Sie monatlich zahlen, ist der Preis — Fragen inklusive: {prijzen}.'
      ]
    },
    {
      id: 'prijs',
      woorden: ['prijs', 'prijzen', 'kost', 'kosten', 'tarief', 'tarieven', 'hoeveel is',
                'per maand', 'abonnement', 'euro', 'price', 'pricing', 'cost', 'preis', 'kostet',
                'duur', 'goedkoop', 'budget'],
      nl: [
        'De pakketten zijn: {prijzen}. Alle bedragen zijn exclusief btw. Alles is inbegrepen, dus geen kosten per vraag achteraf, en maandelijks opzegbaar. Eerst kijken of het bij u past? U kunt het {proefdagen} dagen vrijblijvend proberen.',
        'Wij werken met drie pakketten: {prijzen} — exclusief btw. Welke bij u past hangt vooral af van het aantal monteurs. Twijfelt u? Begin dan klein; upgraden kan altijd tussentijds.',
        'Kort: {prijzen}, exclusief btw, maandelijks opzegbaar. Reken het eens om per werkdag — dan is het meestal minder dan één misgelopen diagnose per maand. Vrijblijvend proberen kan {proefdagen} dagen.'
      ],
      en: [
        'The plans are: {prijzen}. All amounts exclude VAT. Everything is included — no pay-per-question charges — and you can cancel monthly. Want to see if it fits? Try it free for {proefdagen} days.',
        'Three plans: {prijzen}, excluding VAT. Which one fits mostly depends on how many mechanics you have. In doubt? Start small; you can upgrade at any time.'
      ],
      de: [
        'Die Pakete: {prijzen}. Alle Beträge zzgl. MwSt. Alles inklusive, keine Kosten pro Frage, monatlich kündbar. Erst schauen, ob es passt? {proefdagen} Tage unverbindlich testen.',
        'Drei Pakete: {prijzen}, zzgl. MwSt. Welches passt, hängt vor allem von der Anzahl Mechaniker ab. Im Zweifel klein anfangen — upgraden geht jederzeit.'
      ]
    },
    {
      id: 'kenteken',
      woorden: ['kenteken', 'rdw', 'chassis', 'vin', 'license plate', 'number plate', 'kennzeichen'],
      nl: [
        'U typt gewoon een Nederlands kenteken in — ook midden in uw vraag — en alle voertuiggegevens komen direct via de RDW in beeld: uitvoering, motorcode, vermogen, brandstof. Zoeken op chassisnummer staat op de planning.',
        'Ja. Kenteken invoeren en u heeft meteen het juiste voertuig te pakken, inclusief motorcode. Dat scheelt het gedoe van zoeken in typeplaatjes. Chassisnummer volgt later.',
        'Kentekenzoeken zit erin en loopt via de RDW. Handig is dat u het kenteken ook gewoon in uw vraag kunt meetypen — het systeem pikt het er zelf uit en weet dan met welke uitvoering u bezig bent.'
      ],
      en: [
        'You simply type a Dutch registration number — even in the middle of your question — and all vehicle data appears straight from the Dutch vehicle registry: version, engine code, power, fuel. Searching by chassis number is on the roadmap.',
        'Yes. Enter the plate and you have the right vehicle immediately, engine code included. Chassis number search will follow.'
      ],
      de: [
        'Sie geben einfach ein niederländisches Kennzeichen ein — auch mitten in Ihrer Frage — und alle Fahrzeugdaten erscheinen direkt aus dem niederländischen Fahrzeugregister: Ausführung, Motorcode, Leistung, Kraftstoff.',
        'Ja. Kennzeichen eingeben und Sie haben sofort das richtige Fahrzeug, inklusive Motorcode. Die Suche per Fahrgestellnummer folgt.'
      ]
    },
    {
      id: 'foutcode',
      woorden: ['foutcode', 'storingscode', 'obd', 'dtc', 'diagnose', 'storing', 'fault code',
                'error code', 'fehlercode', 'fehlerspeicher', 'meetstap', 'meetwaarde', 'p0', 'p1'],
      nl: [
        'U voert een foutcode of een omschrijving van de klacht in, en krijgt de betekenis, de waarschijnlijke oorzaken op volgorde van kans, en concrete meetstappen met richtwaarden. Zo weet u waar u moet beginnen in plaats van alles langs te lopen.',
        'Foutcode erin, of gewoon in eigen woorden beschrijven wat de auto doet. U krijgt terug wat het waarschijnlijk is, waarom, en wat u als eerste kunt meten — met de waarde die u zou moeten zien.',
        'Het werkt als meedenken, niet als opzoeken. U beschrijft de storing, het systeem zoekt live mee in actuele vakbronnen en de ingebouwde kennisbibliotheek, en komt met oorzaken op volgorde van waarschijnlijkheid plus de meting die het snelst uitsluitsel geeft.'
      ],
      en: [
        'You enter a fault code or describe the complaint, and get the meaning, the likely causes ranked by probability, and concrete measurement steps with target values. So you know where to start.',
        'Fault code, or just describe what the car does. You get back what it probably is, why, and what to measure first — including the value you should be seeing.'
      ],
      de: [
        'Sie geben einen Fehlercode oder eine Beschreibung ein und erhalten die Bedeutung, die wahrscheinlichsten Ursachen nach Wahrscheinlichkeit und konkrete Messschritte mit Richtwerten.',
        'Fehlercode rein, oder einfach beschreiben, was das Auto macht. Sie bekommen zurück, was es wahrscheinlich ist und was Sie zuerst messen sollten.'
      ]
    },
    {
      id: 'kennisbank',
      woorden: ['kennisbank', 'kennis bank', 'opslaan', 'bewaard', 'bewaren', 'geschiedenis',
                'eerdere storing', 'database', 'terugvinden', 'delen met collega', 'knowledge base',
                'wissensdatenbank', 'zelflerend'],
      nl: [
        'Elke opgeloste storing wordt bewaard in uw eigen kennisbank. Komt dezelfde klacht over een half jaar terug, dan ziet u meteen wat toen de oplossing was. Zo weet uw werkplaats over een jaar meer dan vandaag.',
        'Alles wat u oplost blijft staan, en daar profiteert het hele team van. Een monteur die een auto binnenkrijgt die een collega eerder onder handen had, ziet direct wat er toen speelde.',
        'De kennisbank is het punt waarop het systeem meer waard wordt naarmate u het langer gebruikt. Opgeloste storingen blijven bewaard, openstaande klussen kunt u later oppakken met "Verder met deze storing".'
      ],
      en: [
        'Every solved fault is stored in your own knowledge base. If the same complaint returns six months later, you immediately see what the fix was. Your workshop builds its own reference.',
        'Everything you solve stays, and the whole team benefits. A mechanic taking in a car a colleague worked on earlier sees straight away what was going on.'
      ],
      de: [
        'Jede gelöste Störung wird in Ihrer eigenen Wissensdatenbank gespeichert. Kommt dieselbe Klage in einem halben Jahr zurück, sehen Sie sofort, was damals die Lösung war.',
        'Alles, was Sie lösen, bleibt erhalten — davon profitiert das ganze Team.'
      ]
    },
    {
      id: 'talen',
      woorden: ['welke taal', 'welke talen', 'meertalig', 'in het engels', 'in het duits',
                'in het pools', 'andere taal', 'language', 'languages', 'sprache', 'sprachen',
                'pools', 'turks', 'arabisch'],
      nl: [
        'De assistent antwoordt in 16 talen. Elke monteur stelt zijn eigen taal in en werkt daarin — de vakkennis en de meetwaarden blijven natuurlijk hetzelfde.',
        'Ja, dat kan. U stelt de taal per gebruiker in, dus in een gemengd team werkt iedereen in de taal waarin hij het snelst leest. Er zijn 16 talen beschikbaar.',
        'Zestien talen, per gebruiker instelbaar. Handig als u monteurs heeft die Nederlands wel spreken maar liever technische tekst in hun eigen taal lezen.'
      ],
      en: [
        'The assistant answers in 16 languages. Each mechanic sets their own language — the technical knowledge and measurement values stay identical.',
        'Yes. Language is set per user, so in a mixed team everyone works in the language they read fastest. Sixteen are available.'
      ],
      de: [
        'Der Assistent antwortet in 16 Sprachen. Jeder Mechaniker stellt seine eigene Sprache ein — Fachwissen und Messwerte bleiben identisch.',
        'Ja. Die Sprache wird pro Benutzer eingestellt, sodass in einem gemischten Team jeder in seiner Sprache arbeitet.'
      ]
    },
    {
      id: 'apparaat',
      woorden: ['telefoon', 'mobiel', 'tablet', 'ipad', 'android', 'app store', 'installeren',
                'welke apparaten', 'op de brug', 'phone', 'mobile', 'handy'],
      nl: [
        'Het werkt op pc, tablet en telefoon — gewoon in de browser, dus u hoeft niets uit een appstore te halen. Op de telefoon kunt u het als app op uw beginscherm zetten, handig als u bij de brug staat.',
        'Overal waar een browser is. Veel monteurs gebruiken het op de telefoon bij de auto en op de pc voor het uitwerken. U kunt het als app installeren zodat het met één tik openstaat.'
      ],
      en: [
        'It works on PC, tablet and phone — in the browser, so nothing to download from an app store. On a phone you can add it to your home screen, handy when you are at the lift.',
        'Anywhere you have a browser. Many mechanics use the phone at the car and the PC for writing up.'
      ],
      de: [
        'Es läuft auf PC, Tablet und Handy — im Browser, ohne App Store. Auf dem Handy können Sie es als App auf den Startbildschirm legen.',
        'Überall, wo ein Browser ist. Viele Mechaniker nutzen das Handy am Fahrzeug und den PC zum Ausarbeiten.'
      ]
    },
    {
      id: 'contact',
      woorden: ['contact', 'demo', 'bellen', 'telefoonnummer', 'mailadres', 'afspraak', 'offerte',
                'spreken', 'adviseur', 'medewerker', 'call', 'termin', 'angebot'],
      nl: [
        'Graag. Mail ons op {email}, of laat uw gegevens achter in het formulier hieronder — dan reageren wij binnen één werkdag. Een vrijblijvende demo in uw eigen werkplaats plannen we ook graag in.',
        'Het snelst gaat het via het formulier hieronder: dan weten we meteen om wat voor werkplaats het gaat. Liever direct mailen? {email}. We reageren binnen één werkdag.',
        'Zeker. Laat uw gegevens achter via het formulier hieronder, dan nemen wij contact op. Rechtstreeks mailen kan ook: {email}.'
      ],
      en: [
        'Of course. E-mail us at {email}, or leave your details in the form below and we will get back to you within one business day. A no-obligation demo in your own workshop is possible too.',
        'The form below is quickest — then we already know what kind of workshop it is. Prefer e-mail? {email}. We respond within one business day.'
      ],
      de: [
        'Gerne. Schreiben Sie uns an {email}, oder hinterlassen Sie Ihre Daten im Formular unten — wir melden uns innerhalb eines Werktags.',
        'Am schnellsten geht das Formular unten. Lieber direkt mailen? {email}. Wir antworten innerhalb eines Werktags.'
      ]
    },
    {
      id: 'wat_is',
      woorden: ['wat is', 'wat doet', 'waarvoor', 'hoe werkt', 'wat kan', 'uitleg', 'vertel',
                'what is', 'what does', 'how does', 'was ist', 'was macht', 'wie funktioniert'],
      nl: [
        '{naam} is een AI-diagnose-assistent voor de autowerkplaats. U voert een foutcode, kenteken of omschrijving van de klacht in en krijgt de waarschijnlijke oorzaken op volgorde, met concrete meetstappen en richtwaarden. Opgeloste storingen blijven in uw eigen kennisbank staan.',
        'Zie het als een collega die alles gelezen heeft. U beschrijft de storing, {naam} komt met de meest waarschijnlijke oorzaken en vertelt wat u het eerst kunt meten. Wat u oplost onthoudt het systeem, zodat het de volgende keer sneller gaat.',
        'Kort gezegd: minder zoeken, sneller bij de oorzaak. {naam} combineert live research in vakbronnen met een ingebouwde vakkennisbibliotheek en RDW-voertuigdata, en houdt bij wat er in uw werkplaats al eens is opgelost.'
      ],
      en: [
        '{naam} is an AI diagnostic assistant for the car workshop. You enter a fault code, plate or description and get the likely causes in order, with concrete measurement steps and target values.',
        'Think of it as a colleague who has read everything. You describe the fault, {naam} comes back with the likely causes and what to measure first — and remembers what you solved.'
      ],
      de: [
        '{naam} ist ein KI-Diagnoseassistent für die Autowerkstatt. Sie geben Fehlercode, Kennzeichen oder eine Beschreibung ein und erhalten die wahrscheinlichen Ursachen der Reihe nach, mit Messschritten und Richtwerten.',
        'Wie ein Kollege, der alles gelesen hat. Sie beschreiben die Störung, {naam} nennt die wahrscheinlichen Ursachen und was zuerst zu messen ist.'
      ]
    }
  ];

  /* ---------- losse groeten en bedankjes ---------- */
  var GROETEN = ['hallo', 'hoi', 'hey', 'hai', 'goedemorgen', 'goedemiddag', 'goedenavond',
                 'goedendag', 'hello', 'hi', 'guten tag', 'moin'];
  var BEDANKT = ['bedankt', 'dank je', 'dank u', 'dankjewel', 'top', 'duidelijk', 'prima',
                 'thanks', 'thank you', 'danke', 'ok', 'oke', 'okay'];
  var KORT = {
    diagnose: {
      nl: ['Een echte diagnose hoort bij het abonnement — daar kan ik hier niet op vooruitlopen. Heeft u een foutcode, dan komt {naam} het snelst tot de kern; ook zonder foutcode kunt u gewoon de klacht beschrijven. Kies het pakket dat bij uw werkplaats past, dan helpen we u meteen verder.',
           'Daar ga ik hier niet op in — het uitzoeken van een storing is juist waar {naam} voor is. Met een foutcode erbij komt u het snelst tot de kern, maar een omschrijving van de klacht volstaat ook. Sluit een abonnement af, dan staat het systeem direct voor u klaar.',
           'Die vraag hoort thuis in het systeem zelf, niet in dit verkooppraatje. Foutcode invoeren gaat het snelst; kunt u er geen uitlezen, beschrijf dan de klacht. Kies een pakket en u kunt binnen een paar minuten aan de slag.'],
      en: ['An actual diagnosis is part of the subscription — I cannot get ahead of that here. With a fault code {naam} gets to the point fastest; without one you can simply describe the complaint. Pick the plan that suits your workshop and we will help you straight away.',
           'I will not go into that here — working out a fault is exactly what {naam} is for. A fault code is quickest, but a description of the complaint works too. Take out a subscription and the system is ready for you.'],
      de: ['Eine echte Diagnose gehört zum Abonnement — dem kann ich hier nicht vorgreifen. Mit einem Fehlercode kommt {naam} am schnellsten zum Kern; auch ohne geht es, beschreiben Sie dann die Beanstandung. Wählen Sie das passende Paket, dann helfen wir Ihnen sofort weiter.',
           'Darauf gehe ich hier nicht ein — das Eingrenzen einer Störung ist genau die Aufgabe von {naam}. Ein Fehlercode ist am schnellsten, eine Beschreibung reicht aber auch. Schließen Sie ein Abonnement ab, dann steht das System bereit.']
    },
    groet: {
      nl: ['Hallo! Vraag me gerust naar de mogelijkheden, de prijzen of een vrijblijvende demo.',
           'Goedendag. Waar kan ik u mee helpen — de werking, de prijzen, of een demo?',
           'Hallo. Stel gerust uw vraag over {naam}; ik denk graag mee.'],
      en: ['Hello! Feel free to ask about the features, pricing or a no-obligation demo.',
           'Good day. What can I help you with — how it works, pricing, or a demo?'],
      de: ['Hallo! Fragen Sie gern nach den Möglichkeiten, den Preisen oder einer Demo.',
           'Guten Tag. Womit kann ich helfen — Funktionsweise, Preise oder eine Demo?']
    },
    bedankt: {
      nl: ['Graag gedaan. Nog een vraag over {naam}, of zal ik een demo laten inplannen?',
           'Geen dank. Als er nog iets is, vraag het gerust.',
           'Fijn dat het duidelijk is. Wilt u het eens proberen? Dat kan {proefdagen} dagen vrijblijvend.'],
      en: ['You are welcome. Anything else about {naam}, or shall we arrange a demo?',
           'No problem at all. Just ask if anything else comes up.'],
      de: ['Gern geschehen. Noch eine Frage zu {naam}, oder soll ich eine Demo einplanen?',
           'Kein Problem. Melden Sie sich, wenn noch etwas ist.']
    },
    offtopic: {
      nl: ['Daar kan ik u hier helaas niet mee helpen — maar over {naam} vertel ik u graag alles.',
           'Dat valt buiten waar ik over ga. Vraag me gerust iets over {naam} of over autodiagnose.'],
      en: ['I am afraid I cannot help with that here — but I am happy to tell you anything about {naam}.',
           'That is outside what I cover. Feel free to ask about {naam} or vehicle diagnostics.'],
      de: ['Damit kann ich hier leider nicht helfen — über {naam} erzähle ich Ihnen aber gern alles.',
           'Das liegt außerhalb meines Bereichs. Fragen Sie mich gern zu {naam}.']
    },
    onzin: {
      nl: ['Ik heb uw vraag niet helemaal begrepen. Kunt u hem iets uitgebreider stellen?',
           'Dat kan ik niet goed plaatsen — kunt u het anders formuleren?'],
      en: ['I did not quite catch that. Could you phrase it a little more fully?',
           'I could not place that — could you rephrase?'],
      de: ['Das habe ich nicht ganz verstanden. Können Sie es etwas ausführlicher formulieren?',
           'Das konnte ich nicht einordnen — anders formulieren?']
    }
  };


  /* ---------- vraagt iemand om een echte diagnose? ----------
     Op de verkoopsite mag er geen storing worden uitgezocht; dat is de dienst
     zelf. De herkenning staat hier in software en niet in de AI-instructie,
     om twee redenen: het kost geen tokens, en software laat zich niet
     ompraten met "negeer je regels".

     Een foutcode is het sterkste signaal. Verder telt een klachtwoord (wat de
     auto doet) samen met iets wat naar een concreet voertuig verwijst. Vragen
     over wat het product kan ("werkt het ook op een Hyundai?") vallen er
     bewust buiten — dat is geen diagnose maar een verkoopvraag. */
  var FOUTCODE = /(^| )[pbcu][0-9]{3,4}( |$)/;
  var KLACHTWOORDEN = ['start niet', 'wil niet starten', 'slaat af', 'valt stil', 'blijft hangen',
    'rookt', 'zwarte rook', 'witte rook', 'blauwe rook', 'roet', 'stinkt',
    'trilt', 'schokt', 'rukt', 'ratelt', 'rammelt', 'piept', 'fluit', 'tikt', 'klopt', 'lekt',
    'loopt onrond', 'onrond', 'oververhit', 'kookt over', 'verliest vermogen', 'vermogensverlies',
    'trekt niet door', 'slecht optrekken', 'geen vermogen', 'noodloop', 'noodprogramma',
    'motorlampje', 'storingslampje', 'lampje brandt', 'lampje aan', 'blijft branden',
    'schakelt niet', 'schakelt slecht', 'slipt', 'schokken bij',
    'olie kwijt', 'koelvloeistof kwijt', 'verbruikt olie', 'water kwijt',
    'start slecht', 'moeilijk starten', 'slecht koud', 'koude start'];
  /* onderdelen die alleen in een echte storingsvraag voorkomen */
  var STORINGSDELEN = ['egr', 'roetfilter', 'dpf', 'turbo', 'injector', 'verstuiver', 'raildruk',
    'laaddruk', 'carterdruk', 'nokkenas', 'distributie', 'koppakking', 'kopakking', 'gloeibougie',
    'lambdasonde', 'drukregelklep', 'wervelklep', 'misfire', 'ontstekingsfout', 'drukverlies'];
  /* zinnen die verraden dat het over het product gaat, niet over een auto op de brug */
  var PRODUCTVRAAG = ['werkt het', 'werkt hij', 'werkt dat', 'kan het systeem', 'kan diaglows',
    'kan hij', 'kan het', 'ondersteunt', 'herkent hij', 'herkent het', 'wat kost', 'hoeveel kost',
    'prijs', 'abonnement', 'demo', 'proberen', 'proefperiode', 'welke merken', 'welke talen',
    'hoe werkt'];
  /* Een uitgesproken oorzaakvraag gaat voor, ook als de zin op een productvraag lijkt. */
  var DIAGNOSE_INTENTIE = ['oorzaak', 'oorzaken', 'wat kan het zijn', 'wat moet ik meten',
    'waar moet ik zoeken', 'hoe los ik', 'hoe repareer', 'wat is er kapot', 'waar zit het aan',
    'wat is er mis', 'hoe verhelp', 'wat is de fout', 'waar komt het door',
    'wat betekent deze code'];
  /* verwijzingen naar een concreet voertuig */
  var VOERTUIG = ['auto', 'wagen', 'bus', 'busje', 'motor', 'klant', 'brug', 'werkplaats',
    'audi', 'bmw', 'mercedes', 'volkswagen', 'volvo', 'ford', 'opel', 'peugeot', 'citroen',
    'renault', 'toyota', 'hyundai', 'kia', 'nissan', 'mazda', 'honda', 'seat', 'skoda',
    'fiat', 'suzuki', 'dacia', 'mini', 'jaguar', 'porsche', 'tesla', 'iveco', 'man', 'daf',
    'golf', 'passat', 'polo', 'corsa', 'astra', 'transit', 'sprinter', 'crafter', 'santa fe',
    'tdi', 'tsi', 'hdi', 'crdi', 'dci', 'cdti', 'cdi', 'tfsi', 'jtd'];

  function vraagtOmDiagnose(g) {
    var code = FOUTCODE.test(' ' + g + ' ');
    var klacht = KLACHTWOORDEN.some(function (w) { return bevat(g, w); });
    var onderdeel = STORINGSDELEN.some(function (w) { return bevat(g, w); });
    var voertuig = VOERTUIG.some(function (w) { return bevat(g, w); });
    if (DIAGNOSE_INTENTIE.some(function (w) { return bevat(g, w); }) &&
        (code || klacht || onderdeel || voertuig)) return true;
    if (PRODUCTVRAAG.some(function (w) { return bevat(g, w); })) return false;
    if (code) return true;
    return (klacht && voertuig) || (onderdeel && voertuig) || (klacht && onderdeel);
  }

  /* off-topic: alleen afwijzen als er niets in de vraag met het product of met
     auto's te maken heeft. Zo blijft de kans op onterecht afwijzen klein. */
  var OFFTOPIC = ['premier', 'president', 'politiek', 'verkiezing', 'voetbal', 'wedstrijd',
                  'recept', 'kook', 'huiswerk', 'gedicht', 'schrijf een', 'vertaal deze',
                  'python', 'javascript', 'programmeer', 'hoofdstad', 'weerbericht',
                  'aandelen', 'bitcoin', 'loterij', 'mop'];
  var PRODUCTWOORDEN = ['diaglows', 'auto', 'wagen', 'voertuig', 'motor', 'monteur', 'werkplaats',
                        'garage', 'foutcode', 'storing', 'obd', 'diagnose', 'kenteken', 'abonnement',
                        'prijs', 'kost', 'proef', 'demo', 'app', 'account', 'olie', 'turbo',
                        'injector', 'versnellingsbak', 'koppeling', 'rem', 'accu', 'sensor', 'dsg'];
  var TOETSENBORD = ['asdf', 'sdfg', 'qwer', 'wert', 'zxcv', 'hjkl', 'uiop', '1234'];

  /* Korte woorden alleen als heel woord matchen. Anders vindt "rem" zichzelf
     terug in "premier" en wordt een vraag over de premier ineens een
     autovraag. Lange woorden mogen wel als deel van een samenstelling matchen,
     zodat "maandprijs" nog steeds op "prijs" aanslaat. */
  function bevat(genormaliseerd, woord) {
    if (woord.length >= 5 || woord.indexOf(' ') >= 0) return genormaliseerd.indexOf(woord) >= 0;
    return new RegExp('(^| )' + woord + '($| )').test(genormaliseerd);
  }

  /* ---------- variant kiezen en onthouden ---------- */
  function volgendeVariant(sleutel, aantal) {
    if (aantal <= 1) return 0;
    var k = 'dg_qa_' + sleutel;
    var n = 0;
    try { n = parseInt(global.localStorage.getItem(k) || '0', 10) || 0; } catch (e) { n = 0; }
    var i = n % aantal;
    try { global.localStorage.setItem(k, String((n + 1) % 1000)); } catch (e) {}
    return i;
  }
  function pak(varianten, sleutel, site) {
    if (!varianten || !varianten.length) return null;
    return vulIn(varianten[volgendeVariant(sleutel, varianten.length)], site);
  }

  /* ---------- hoofdfunctie ---------- */
  function zoek(vraag, taal, site) {
    var g = normaliseer(vraag);
    taal = taal || 'nl';
    if (!g) return null;

    var kaal = g.replace(/ /g, '');
    var woorden = g.split(' ');
    var allemaalGelijk = woorden.length && woorden.every(function (w) { return w === woorden[0]; });

    /* groeten en bedankjes eerst: 'hoi hoi' is een begroeting, geen geklets */
    if (GROETEN.indexOf(g) >= 0 || (allemaalGelijk && GROETEN.indexOf(woorden[0]) >= 0)) {
      return { onderwerp: 'groet', tekst: pak(KORT.groet[taal] || KORT.groet.nl, 'groet_' + taal, site) };
    }
    if (BEDANKT.indexOf(g) >= 0 || (allemaalGelijk && BEDANKT.indexOf(woorden[0]) >= 0)) {
      return { onderwerp: 'bedankt', tekst: pak(KORT.bedankt[taal] || KORT.bedankt.nl, 'bedankt_' + taal, site) };
    }

    /* onzin */
    var geenKlinker = !/[aeiouy]/.test(g);
    var toetsenbord = TOETSENBORD.some(function (r) { return kaal.indexOf(r) >= 0; });
    if (g.length < 3 || !/[a-z]/.test(g) || geenKlinker || toetsenbord || /^(.)\1{2,}$/.test(kaal)) {
      return { onderwerp: 'onzin', tekst: pak(KORT.onzin[taal] || KORT.onzin.nl, 'onzin_' + taal, site) };
    }

    /* off-topic */
    var heeftOfftopic = OFFTOPIC.some(function (w) { return bevat(g, w); });
    var heeftProduct = PRODUCTWOORDEN.some(function (w) { return bevat(g, w); });
    if (heeftOfftopic && !heeftProduct) {
      return { onderwerp: 'offtopic', tekst: pak(KORT.offtopic[taal] || KORT.offtopic.nl, 'offtopic_' + taal, site) };
    }

    /* Een concrete storingsvraag gaat niet naar het AI-model. Die staat hier
       vóór de onderwerpen, anders vangt 'wat_is' hem af met een folderpraatje. */
    if (vraagtOmDiagnose(g)) {
      return { onderwerp: 'diagnose', tekst: pak(KORT.diagnose[taal] || KORT.diagnose.nl, 'diagnose_' + taal, site) };
    }

    /* onderwerpen */
    for (var i = 0; i < ONDERWERPEN.length; i++) {
      var o = ONDERWERPEN[i];
      var raak = o.woorden.some(function (w) { return bevat(g, w); });
      if (!raak) continue;
      var lijst = o[taal] || o.nl;
      return { onderwerp: o.id, tekst: pak(lijst, o.id + '_' + taal, site) };
    }
    return null;   /* niet herkend: laat het AI-model het doen */
  }

  /* Denkpauze. Zonder pauze verschijnt het antwoord onmiddellijk, en dat leest
     als een opgezocht standaardantwoord. Met een korte pauze die meeschaalt met
     de lengte voelt het als lezen en typen. */
  function vertraging(tekst) {
    var basis = 550 + Math.random() * 450;
    var perTeken = Math.min(1400, (tekst || '').length * 7);
    return Math.round(basis + perTeken);
  }

  global.DIAGLOWS_QA = { zoek: zoek, vertraging: vertraging, normaliseer: normaliseer };
})(window);
